module.exports = __webpack_public_path__ + "img/10000.216754e8.jpg";